export default {
  bankers: `profile/bankers`,
  update: `profile/bankers/update`,
  remove: `profile/bankers/remove`,
};
